import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { fmtDate } from "../lib/status";
import { Copy, Mail } from "lucide-react";
import { toast } from "sonner";

export default function Notifications() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/notifications").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  const copy = async (link) => {
    await navigator.clipboard.writeText(link);
    toast.success("Copied");
  };

  return (
    <div className="space-y-6" data-testid="notifications-page">
      <div>
        <h1 className="font-display text-3xl sm:text-4xl font-bold">Messages Sent</h1>
        <p className="text-slate-600 mt-1">All emails sent by ConfirmPH. Currently in <span className="font-medium">mock mode</span>: links are copyable for testing.</p>
      </div>

      <div className="rounded-xl border border-slate-200 bg-white">
        {loading && <div className="p-6 text-slate-500">Loading…</div>}
        {!loading && items.length === 0 && <div className="p-10 text-center text-slate-500">No notifications yet.</div>}
        <ul className="divide-y divide-slate-100">
          {items.map((n) => (
            <li key={n.id} className="p-4" data-testid={`notification-${n.id}`}>
              <div className="flex items-start justify-between gap-3 flex-wrap">
                <div className="min-w-0">
                  <div className="flex items-center gap-2">
                    <Mail className="w-4 h-4 text-slate-500" />
                    <span className="font-medium">{n.subject}</span>
                  </div>
                  <div className="text-xs text-slate-500 mt-0.5">
                    {n.channel} → {n.recipient} · {fmtDate(n.created_at)} · {n.notification_type}
                  </div>
                </div>
                <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-emerald-100 text-emerald-800 border border-emerald-200">
                  {n.status}
                </span>
              </div>
              {n.message_body && (
                <p className="mt-2 text-sm text-slate-700 whitespace-pre-line">{n.message_body}</p>
              )}
              {n.link && (
                <div className="mt-2 flex items-center gap-2 flex-wrap">
                  <code className="text-xs bg-slate-100 rounded px-2 py-1 break-all flex-1 min-w-0">{n.link}</code>
                  <button onClick={() => copy(n.link)} className="px-2.5 py-1 rounded-md border border-slate-300 hover:bg-slate-50 text-xs inline-flex items-center gap-1" data-testid={`copy-${n.id}`}>
                    <Copy className="w-3 h-3" /> Copy
                  </button>
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
